import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-fbc2dffa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "margin-bottom": "10px",
    "display": "flex",
    "justify-content": "center"
  }
};
const _hoisted_2 = {
  style: {
    "margin-bottom": "20px",
    "display": "flex",
    "flex-wrap": "wrap"
  }
};
const _hoisted_3 = {
  style: {
    "max-height": "calc(100vh - 140px)",
    "overflow": "auto",
    "display": "flex",
    "flex-wrap": "wrap"
  }
};
const _hoisted_4 = ["src", "onClick"];
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = ["width", "height"];
const _hoisted_7 = ["d", "fill", "stroke"];
const _hoisted_8 = ["onDragstart", "onDragend", "onClick"];
const _hoisted_9 = ["onUpdate:modelValue"];
const _hoisted_10 = ["onUpdate:modelValue"];
const _hoisted_11 = ["onClick", "onDragstart", "onDragend"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "预览", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "画布尺寸", -1));
const _hoisted_16 = {
  style: {
    "margin-bottom": "4px"
  }
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "背景色", -1));
const _hoisted_18 = ["onClick"];
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "背景渐变", -1));
const _hoisted_20 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_21 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_22 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "边角弧度", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "边角倾斜", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "元素拖动", -1));
const _hoisted_26 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "内容", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "排列方向", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "字体", -1));
const _hoisted_30 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "颜色", -1));
const _hoisted_31 = ["onClick"];
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "炫彩", -1));
const _hoisted_33 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_34 = {
  key: 0,
  style: {
    "display": "flex",
    "flex-wrap": "wrap"
  }
};
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "阴影", -1));
const _hoisted_38 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_39 = {
  key: 0
};
const _hoisted_40 = {
  style: {
    "display": "flex",
    "flex-wrap": "wrap"
  }
};
const _hoisted_41 = ["onClick"];
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "大小", -1));
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "加粗", -1));
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "旋转", -1));
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "边框", -1));
const _hoisted_46 = ["onClick"];
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "弧度", -1));
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "位置", -1));
const _hoisted_49 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "背景", -1));
const _hoisted_50 = ["onClick"];
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "内边距", -1));
const _hoisted_52 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-weight": "bold"
  },
  class: "form-label"
}, "倾斜", -1));
const _hoisted_53 = {
  key: 2,
  class: "img-detail"
};
const _hoisted_54 = {
  style: {
    "margin": "5px 0 5px 0"
  }
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "取色：", -1));
const _hoisted_56 = {
  style: {
    "margin": "5px 0 5px 0"
  }
};
const _hoisted_57 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "橡皮：", -1));
const _hoisted_58 = {
  style: {
    "margin": "5px 0 5px 0"
  }
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "橡皮擦形状：", -1));
const _hoisted_60 = {
  style: {
    "margin": "5px 0 5px 0"
  }
};
const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "橡皮擦尺寸：", -1));
const _hoisted_62 = {
  style: {
    "margin": "5px 0 5px 0"
  }
};
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "尺寸比：", -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "遮罩层：", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "旋转度：", -1));
const _hoisted_66 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "3d效果：", -1));
const _hoisted_67 = {
  key: 0
};
const _hoisted_68 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_69 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_70 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_71 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_72 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "灰色：", -1));
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "模糊：", -1));
const _hoisted_74 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "透明：", -1));
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "亮度：", -1));
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "复古：", -1));
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "img-handle"
}, "饱和：", -1));
const _hoisted_78 = {
  key: 3
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "尺寸", -1));
const _hoisted_80 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "起始路径", -1));
const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "移动路径", -1));
const _hoisted_82 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_83 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "边宽", -1));
const _hoisted_84 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "边色", -1));
const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "form-label"
}, "填充色", -1));
const _hoisted_86 = ["src"];
import '../assets/fonts/font.css';
import { ref, reactive, onMounted, nextTick } from 'vue';
import { myMixin } from '../mixin.js';
import html2canvas from 'html2canvas'; //引入生成二维码插件
import { domToDataUrl, domToPng } from 'modern-screenshot';
export default {
  __name: 'createImg',
  setup(__props) {
    const {
      errorMsgBox,
      apiAll,
      successMsgBox,
      withLoading,
      random,
      getNewFiles,
      getData,
      handleLabelWidth,
      formDataApi,
      theme
    } = myMixin();
    const fixedImags = reactive([]);
    const logoImgs = ref('logo-imgs'); //添加遮罩层
    const imageSizes = reactive([{
      title: 'iphone15 390*844',
      value: '390_844'
    }, {
      title: '微信头图 360*200',
      value: '360_200'
    }, {
      title: '图标 140*140',
      value: '140_140'
    }, {
      title: 'PC大图 1960*480',
      value: '1960_480'
    }, {
      title: 'PC大图 1024*768',
      value: '1024_768'
    }, {
      title: '简易logo',
      value: '290_70'
    }, {
      title: '图片尺寸',
      value: 'source'
    }
    // {
    // 	title: '当前尺寸',
    // 	value: 'current'
    // }
    ]);

    const ttlList = reactive([{
      name: '宋体',
      fontFamily: '宋体',
      color: '#107BEE'
    }, {
      name: '微软雅黑',
      fontFamily: '微软雅黑',
      color: '#107BEE'
    }, {
      name: '隶书',
      fontFamily: '隶书',
      color: '#107BEE'
    }, {
      name: '方正姚体',
      fontFamily: '方正姚体',
      color: '#107BEE'
    }, {
      name: '华文琥珀',
      fontFamily: '华文琥珀',
      color: '#107BEE'
    }, {
      name: '华文彩云',
      fontFamily: '华文彩云',
      color: '#107BEE'
    }, {
      name: '楷体',
      fontFamily: '楷体',
      color: '#107BEE'
    }, {
      name: '幼圆',
      fontFamily: '幼圆',
      color: '#107BEE'
    }, {
      name: '汉仪',
      fontFamily: 'led26',
      color: '#107BEE'
    }, {
      name: '古风',
      fontFamily: 'led22',
      color: '#107BEE'
    }, {
      name: '可爱',
      fontFamily: 'led23',
      color: '#107BEE'
    }, {
      name: '清新',
      fontFamily: 'led24',
      color: '#107BEE'
    }, {
      name: '小学生',
      fontFamily: 'led25',
      color: '#107BEE'
    }, {
      name: '标准',
      fontFamily: 'led',
      color: '#107BEE'
    }, {
      name: '简约',
      fontFamily: 'led1',
      color: '#107BEE'
    }, {
      name: '纽约',
      fontFamily: 'led2',
      color: '#107BEE'
    }, {
      name: '少女',
      fontFamily: 'led3',
      color: '#107BEE'
    }, {
      name: '铠甲体',
      fontFamily: 'led4',
      color: '#107BEE'
    }, {
      name: '光',
      fontFamily: 'led5',
      color: '#107BEE'
    }, {
      name: '斜体',
      fontFamily: 'led6',
      color: '#107BEE'
    }, {
      name: '星',
      fontFamily: 'led7',
      color: '#107BEE'
    }, {
      name: '懒人',
      fontFamily: 'led8',
      color: '#107BEE'
    }, {
      name: '开到金光',
      fontFamily: 'led9',
      color: '#107BEE'
    }, {
      name: '欢乐',
      fontFamily: 'led10',
      color: '#107BEE'
    }, {
      name: '走',
      fontFamily: 'led11',
      color: '#107BEE'
    }, {
      name: '穷人',
      fontFamily: 'led12',
      color: '#107BEE'
    }, {
      name: '四叶草',
      fontFamily: 'led13',
      color: '#107BEE'
    }, {
      name: '魔法',
      fontFamily: 'led14',
      color: '#107BEE'
    }, {
      name: '涂鸦体',
      fontFamily: 'led15',
      color: '#107BEE'
    }, {
      name: '战斗',
      fontFamily: 'led16',
      color: '#107BEE'
    }, {
      name: '阴影',
      fontFamily: 'led17',
      color: '#107BEE'
    }, {
      name: '我反对',
      fontFamily: 'led18',
      color: '#107BEE'
    }, {
      name: '大胜',
      fontFamily: 'led19',
      color: '#107BEE'
    }]);
    const size = ref('small');
    const currentImageSize = ref('1024_768');
    const fixedColor = reactive(['', '#fff', '#16baaa', '#00883D', '#3e13eb', '#000000', '#1D7D05', 'orange', 'rgb(28, 66, 160)', '#A210F7', 'rgb(251, 194, 235)', 'rgb(161, 140, 209)']);
    const myLogo = reactive({
      inputContent: '',
      color1: '',
      fontSize: 30,
      isBg: '无',
      isIcon: '有',
      isCircle: '否',
      isItalic: '否',
      iconSize: 30,
      textAlign: '否',
      canvasDefaultWidth: 290,
      canvasDefaultHeight: 40,
      texts: [],
      imgs: [],
      isBglist: false,
      //默认不渐变
      bgListDir: 'to top',
      //默认渐变方向
      bglist: [],
      //背景色渐变
      canvasImgDefaultWidth: 1024,
      canvasImgDefaultHeight: 0
    });
    const isDragEnd = ref(false);
    const isDrag = ref(false);
    const isFill = ref(false);
    const isQuse = ref(false);
    const isNew = ref(false);
    const showImg = ref(false);
    const currentNewImg = ref('');
    const buzhi = ref('');
    const arcSize = ref(10); //橡皮擦圆形尺寸
    const canType = ref('circle'); //默认圆形橡皮擦
    const fillColor = ref('');
    const imgColor = ref('');
    const mainHeight = ref(0);
    const imgMainHeight = ref(0);
    const formMaxHeight = ref(0);
    const editHeight = ref(0);
    const imageHeight = ref(0);
    const compressImageHeight = ref(0);
    const currentTtlIndex = ref(0);
    const type = ref();
    const activeName = ref('画布');
    const imgTool = ref('图片列表');
    const currentText = reactive({
      obj: {}
    });
    const currentTextIndex = ref('');
    const currentImg = reactive({
      obj: {}
    });
    const currentTtl = reactive({
      obj: {}
    });
    const img_items = reactive({
      obj: []
    });
    const loadingData = ref(false);
    const currentSourceImg = reactive({
      obj: {}
    });
    const currentSvg = reactive({
      lList: [],
      width: 100,
      height: 100,
      m1: 0,
      m2: 0
    });
    const svgPathTypeList = reactive(['直线', '曲线']);
    const currentSvgPathTypeIndex = ref('直线');
    const page = reactive({
      obj: {
        startPage: 1
      }
    });
    const imgType = ref('');
    onMounted(() => {
      mainHeight.value = window.innerHeight + 'px';
      imgMainHeight.value = window.innerHeight - 63 + 'px';
      formMaxHeight.value = window.innerHeight - 160 + 'px';
      editHeight.value = window.innerHeight - 120 + 'px';
      imageHeight.value = window.innerHeight - 80 + 'px';
      compressImageHeight.value = window.innerHeight - 200 + 'px';
      if (window.sessionStorage.getItem('handleImgType')) {
        type.value = window.sessionStorage.getItem('handleImgType');
      }
      //计算canvas画框高度
      myLogo.canvasImgDefaultHeight = window.innerHeight - 90;
      getFileForHuatu();
    });
    function getImgType(val) {
      imgType.value = val;
      getFileForHuatu();
    }
    function more() {
      page.obj.startPage += 1;
      getFileForHuatu();
    }
    async function getFileForHuatu() {
      loadingData.value = true;
      let data = {
        page: page.obj,
        img_type: imgType.value
      };
      const res = await withLoading(apiAll(data, '/getFileForHuatu'));
      loadingData.value = false;
      if (res.code >= 0) {
        img_items.obj = res.extra;
      } else {
        errorMsgBox(res.message);
      }
    }
    function newText(val) {
      //加入新text
      // const text = Object.assign({}, this.currentText);
      let text = {};
      text.id = random(20);
      text.top = 0;
      text.left = 0;
      text.inputContent = currentText.obj.inputContent ? currentText.obj.inputContent : '画图呀';
      text.fontSize = 25;
      text.fontFamily = '宋体';
      text.textTopPadding = 0;
      text.textLeftPadding = 0;
      text.textRightPadding = 0;
      text.textBottomPadding = 0;
      text.lockDrag = false;
      text.bglist = [];
      text.bgListDir = 'to right'; //默认渐变方向
      text.fontWeight = 0;
      text.isFlex = '横排';
      text.borderRadius = 0;
      text.isBoxShadow = false;
      text.isXuncai = false;
      text.boxShadowColor = 'rgba(149, 157, 165, 0.2)';
      text.boxShadowTop = 0;
      text.boxShadowLeft = 8;
      text.boxShadowBottom = 25;
      text.isTextarea = val ? val : '';
      text.svg = {}; //制作矢量图
      myLogo.texts.push(text);
      // this.currentText.fontSize = text.fontSize;
      // this.currentText.inputContent = text.inputContent;
      // this.currentText.id = text.id;
      currentTextIndex.value = myLogo.texts.length - 1;
      currentText.obj = text;
      successMsgBox('添加成功');
    }
    function selectBgImg(e) {
      let file = e.target.files[0];
      if (!/.(jpg|jpeg|png|JPG|PNG|webp|WEBP)$/.test(e.target.value)) {
        errorMsgBox('图片类型要求：jpeg、jpg、png、webp');
        return false;
      }
      //转化为blob
      let reader = new FileReader();
      reader.onload = e => {
        let data;
        if (typeof e.target.result === 'object') {
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        currentImg.obj = {
          src: data,
          top: 0,
          left: 0,
          id: random(20),
          bili: 1,
          isMask: false,
          transform3d: false,
          perspective3d: 600,
          deg3d: 46,
          x3d: 1,
          y3d: 1,
          z3d: 1,
          grayscale: '',
          opacity: '',
          brightness: '',
          filterBlur: '',
          transformRotate: ''
        };
        currentSourceImg.obj = {
          src: data,
          top: 0,
          left: 0,
          id: random(20),
          bili: 1,
          isMask: false,
          transform3d: false,
          perspective3d: 600,
          deg3d: 46,
          x3d: 1,
          y3d: 1,
          z3d: 1,
          grayscale: '',
          brightness: '',
          opacity: '',
          filterBlur: ''
        };
        const image = new Image();
        image.src = data;
        image.onload = () => {
          //不能超过画布尺寸
          //不要修改图片原始尺寸
          currentImg.obj.width = image.width;
          currentImg.obj.height = image.height;
          currentImg.obj.sourceWidth = image.width;
          currentImg.obj.sourceHeight = image.height;

          //  _this.doResizeImg(img);

          // if (img.height > _this.myLogo.canvasImgDefaultHeight) {
          //   img.perHeight = "60%";
          // }
          myLogo.imgs.push(currentImg.obj);
        };
      };

      //转化为base64
      reader.readAsDataURL(file);
    }
    function gotoText(text, index) {
      // const obj2 = Object.assign({}, text);
      activeName.value = '文字';
      currentText.obj = text;
      currentTextIndex.value = index;
    }

    // 拖拽开始事件
    function dragstart(e, text) {
      if (isDrag.value) {
        text.startclientX = e.clientX; // 记录拖拽元素初始位置
        text.startclientY = e.clientY;
      }
    }
    function selectFixedImg(url) {
      const image = new Image();
      image.src = url;
      let img = {
        src: url,
        top: 0,
        left: 0,
        id: random(20),
        bili: 1,
        isMask: false,
        transform3d: false,
        perspective3d: 600,
        deg3d: 46,
        x3d: 1,
        y3d: 1,
        z3d: 1,
        grayscale: '',
        opacity: '',
        filterBlur: ''
      };
      currentSourceImg.obj = {
        src: url,
        top: 0,
        left: 0,
        id: random(20),
        bili: 1,
        isMask: false,
        transform3d: false,
        perspective3d: 600,
        deg3d: 46,
        x3d: 1,
        y3d: 1,
        z3d: 1,
        grayscale: '',
        opacity: '',
        filterBlur: '',
        transformRotate: ''
      };
      image.onload = () => {
        //不能超过画布尺寸
        img.width = image.width;
        img.height = image.height;
        img.sourceWidth = image.width;
        img.sourceHeight = image.height;
        // _this.doResizeImg(img);

        activeName.value = '图片';
        currentImg.obj = img;
        myLogo.imgs.push(currentImg.obj);
      };
      successMsgBox('添加图片成功！');
    }
    // 拖拽完成事件
    function dragend(e, text) {
      if (!text.lockDrag && isDrag.value) {
        let x = e.clientX - text.startclientX; // 计算偏移量
        let y = e.clientY - text.startclientY;
        text.left += x; // 实现拖拽元素随偏移量移动
        text.top += y;
        // console.log(x);
        // console.log(y);
        if (text.left) {}
      }
    }
    function changeImageSize(val) {
      if (val !== 'source') {
        //  if (val == 'current'){
        // 	console.log(document.querySelector("#my-huabu").offsetWidth);
        // 	myLogo.canvasImgDefaultWidth = document.querySelector("#my-huabu").offsetWidth;
        // 	myLogo.canvasImgDefaultHeight = document.querySelector("#my-huabu").offsetHeight ;
        // } else{
        // 	myLogo.canvasImgDefaultWidth = val.split('_')[0];
        // 	myLogo.canvasImgDefaultHeight = val.split('_')[1];
        // }
        myLogo.canvasImgDefaultWidth = val.split('_')[0];
        myLogo.canvasImgDefaultHeight = val.split('_')[1];
      } else {
        //图片尺寸
        if (myLogo.imgs && myLogo.imgs.length > 0) {
          myLogo.canvasImgDefaultWidth = myLogo.imgs[0].width;
          myLogo.canvasImgDefaultHeight = myLogo.imgs[0].height;
        }
      }
    }
    function changeTextPosition() {
      if (currentText.obj.textPosition == '左上角') {
        currentText.obj.top = 0;
        currentText.obj.left = 0;
      } else if (currentText.obj.textPosition == '右上角') {
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.top = 0;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.right = 0;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.bottom = null;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.left = null;
      } else if (currentText.obj.textPosition == '右下角') {
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.bottom = 0;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.right = 0;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.top = null;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.left = null;
      } else if (currentText.obj.textPosition == '左下角') {
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.bottom = 0;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.left = 0;
        currentText.obj.left = 0;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.top = null;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.right = null;
      } else if (currentText.obj.textPosition == '居中') {
        // document.getElementsByClassName("my-huabu")[
        //   this.currentTextIndex
        // ].style.top = "50%";
        // document.getElementsByClassName("my-huabu")[
        //   this.currentTextIndex
        // ].style.left = "50%";
        // document.getElementsByClassName("my-huabu")[
        //   this.currentTextIndex
        // ].style.transform = "translate(-50%,-50%)";

        //文字输入时候结合文字大小来综合计算
        //高度与字体大小成一定比例

        currentText.obj.top = myLogo.canvasImgDefaultHeight / 2 - (currentText.obj.fontSize + 10) / 2 - currentText.obj.textTopPadding / 2 + currentText.obj.textBottomPadding / 2;

        //宽度的平均值为字体宽度减去左padding的一半加上右panding的一半
        currentText.obj.left = myLogo.canvasImgDefaultWidth / 2 - currentText.obj.fontSize * currentText.obj.inputContent.length / 2 - currentText.obj.textLeftPadding / 2 + currentText.obj.textRightPadding / 2;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.bottom = null;
        document.getElementsByClassName('my-huabu')[currentTextIndex.value].style.right = null;
      }
    }
    function changeFont() {
      currentTtl.obj = ttlList[currentTtlIndex.value];
      myLogo.fontFamily = currentTtl.obj.fontFamily;
      currentText.obj.fontFamily = myLogo.fontFamily;
    }
    //删除元素
    function deleteElement() {
      if (currentText.obj && Object.keys(currentText.obj).length > 0) {
        myLogo.texts.some((element, index) => {
          if (element.id == currentText.obj.id) {
            myLogo.texts.splice(index, 1);
            return true;
          }
        });
        currentText.obj = {};
      }
      if (currentImg.obj) {
        myLogo.imgs.some((element, index) => {
          if (element.id == currentImg.obj.id) {
            myLogo.imgs.splice(index, 1);
            return true;
          }
        });
        currentImg.obj = {};
      }
    }
    function gotoImgTool(img) {
      currentImg.obj = img;
      imgTool.value = '工具';
    }
    function gotoImg(e, text) {
      // const obj2 = Object.assign({}, text);
      currentImg.obj = text;
      activeName.value = '图片';
      if (isQuse.value) {
        getBgColor(e);
      }
      if (isFill.value) {
        fillImg(e);
      }
    }
    function copyImgBase64(content) {
      navigator.clipboard.writeText(content).then(() => {
        successMsgBox('复制成功');
      });
      fillColor.value = content;
    }
    function changeQuse(val) {
      if (val) {
        isFill.value = false;
      }
    }
    function changeFill(val) {
      if (val) {
        isQuse.value = false;
      }
    }
    function getBgColor(e) {
      var x = e.layerX;
      var y = e.layerY;
      // 加载并显示图像到canvas上
      var img = new Image();
      img.src = currentImg.obj.src; // 这里需要将'path/to/your/image.jpg'替换为实际图像的路径
      let classId = 'quse' + currentImg.obj.id;
      img.onload = function () {
        // 创建一个新的canvas元素
        var canvas = document.querySelector('#' + classId);
        if (!canvas) {
          canvas = document.createElement('canvas');
          canvas.setAttribute('id', classId); //添加样式属性

          document.body.appendChild(canvas);
        }

        // 设置canvas大小与要处理的图像相同
        canvas.width = img.width; // 这里需要将imageWidth替换为实际图像的宽度
        canvas.height = img.height; // 这里需要将imageHeight替换为实际图像的高度

        // 获取2D上下文对象
        var context = canvas.getContext('2d');
        context.drawImage(img, 0, 0); // 将图像绘制到canvas上

        // 从canvas上读取指定位置的像素数据
        var pixelData = context.getImageData(x, y, 1, 1).data;

        // 提取RGB分量的值
        var redValue = pixelData[0];
        var greenValue = pixelData[1];
        var blueValue = pixelData[2];

        // console.log('红色分量：' + redValue);
        // console.log('绿色分量：' + greenValue);
        // console.log('蓝色分量：' + blueValue);
        imgColor.value = 'rgb(' + redValue + ',' + greenValue + ',' + blueValue + ')';
        //alert(_this.imgColor);
        //_this.myLogo.bg = _this.imgColor;
        // alert(canvas.toDataURL());
        canvas.setAttribute('style', 'display:none'); //添加样式属性
      };
    }

    function fillImg(e) {
      var x = e.layerX;
      var y = e.layerY;
      // 加载并显示图像到canvas上
      var img = new Image();
      img.src = currentImg.obj.src; // 这里需要将'path/to/your/image.jpg'替换为实际图像的路径
      let classId = 'quse' + currentImg.obj.id;
      // 创建一个新的canvas元素
      var canvas = document.querySelector('#' + classId);
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.setAttribute('id', classId); //添加样式属性
        canvas.width = img.width; // 这里需要将imageWidth替换为实际图像的宽度
        canvas.height = img.height; // 这里需要将imageHeight替换为实际图像的高度
        document.body.appendChild(canvas);
        canvas.setAttribute('style', 'display:none'); //添加样式属性
      }

      let newSrc = '';
      img.onload = function () {
        // // 获取2D上下文对象
        var ctx = canvas.getContext('2d');
        //设置canvas大小与要处理的图像相同
        ctx.drawImage(img, 0, 0); // 将图像绘制到canvas上

        // //思路： 从canvas上读取指定位置的像素数据，然后循环遍历将该像素附近+10 -10范围内全部替换成透明色
        // var fixedImageData = ctx.getImageData(x, y, 1, 1);
        // var allImgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        // console.log(
        //   fixedImageData.data[0] +
        //     fixedImageData.data[1] +
        //     fixedImageData.data[2] +
        //     fixedImageData.data[3]
        // );
        // for (let i = 0; i < allImgData.data.length; i += 4) {
        //   if (
        //     (allImgData.data[i] == fixedImageData.data[0] &&
        //       allImgData.data[i + 1] == fixedImageData.data[1] &&
        //       allImgData.data[i + 2] == fixedImageData.data[2]) ||
        //     (allImgData.data[i] == 255 &&
        //       allImgData.data[i + 1] == 255 &&
        //       allImgData.data[i + 2] == 255) ||
        //     (allImgData.data[i] == 248 &&
        //       allImgData.data[i + 1] == 248 &&
        //       allImgData.data[i + 2] == 248) ||
        //     (allImgData.data[i] == 247 &&
        //       allImgData.data[i + 1] == 247 &&
        //       allImgData.data[i + 2] == 247) ||
        //     (allImgData.data[i] == 246 &&
        //       allImgData.data[i + 1] == 246 &&
        //       allImgData.data[i + 2] == 246) ||
        //     (allImgData.data[i] == 246 &&
        //       allImgData.data[i + 1] == 247 &&
        //       allImgData.data[i + 2] == 248) ||
        //     (allImgData.data[i] == 250 &&
        //       allImgData.data[i + 1] == 251 &&
        //       allImgData.data[i + 2] == 252) ||
        //     (allImgData.data[i] == 251 &&
        //       allImgData.data[i + 1] == 251 &&
        //       allImgData.data[i + 2] == 251)
        //   ) {
        //     allImgData.data[i] = "255";
        //     allImgData.data[i + 1] = "2550";
        //     allImgData.data[i + 2] = "255";
        //     allImgData.data[i + 3] = "0";
        //   }
        // }
        // 将新像素数据放回Canvas
        // ctx.putImageData(allImgData, 0, 0);

        // 指定要获取颜色的位置（x、y）
        // 先将背景色填充为透明，以便后面可以看到背景图片
        ctx.globalCompositeOperation = 'destination-out';
        // 设置背景擦除区域的大小
        ctx.fillRect(x, y, 1, 1);
        // 重置合成操作为默认值
        ctx.globalCompositeOperation = 'source-over';
        // 设置新的背景色
        ctx.fillStyle = fillColor.value; // 替换为你想要的颜色
        ctx.beginPath();
        if (canType.value == 'circle') {
          ctx.arc(x, y, arcSize.value, 0, 2 * Math.PI); // 创建一个圆形的背景色填充区域
        } else {
          ctx.rect(x, y, arcSize.value, arcSize.value); // 创建一个矩形的背景色填充区域
        }

        ctx.fill();
        newSrc = canvas.toDataURL();
        currentImg.obj.src = newSrc;
      };
    }

    //撤销所有操作，包括还原图片
    function cancelHandleImg() {
      currentImg.obj.src = currentSourceImg.obj.src;
      currentImg.obj.top = currentSourceImg.obj.top;
      currentImg.obj.left = currentSourceImg.obj.left;
      currentImg.obj.id = currentSourceImg.obj.id;
      currentImg.obj.bili = currentSourceImg.obj.bili;
      currentImg.objgrayscale = currentSourceImg.obj.grayscale;
      currentImg.obj.opacity = currentSourceImg.obj.opacity;
      currentImg.obj.brightness = currentSourceImg.obj.brightness;
      currentImg.obj.filterBlur = currentSourceImg.obj.filterBlur;
      currentImg.obj.transformRotate = currentSourceImg.obj.transformRotate;
      currentImg.obj.isMask = currentSourceImg.obj.isMask;
      currentImg.obj.transform3d = currentSourceImg.obj.transform3d;
      currentImg.obj.perspective3d = currentSourceImg.obj.perspective3d;
      currentImg.obj.deg3d = currentSourceImg.obj.deg3d;
      currentImg.obj.x3d = currentSourceImg.obj.x3d;
      currentImg.obj.y3d = currentSourceImg.obj.y3d;
      currentImg.obj.z3d = currentSourceImg.obj.z3d;
    }
    function doResizeImg(val) {
      currentImg.obj.height = currentImg.obj.sourceHeight * val / 100;
      currentImg.obj.width = currentImg.obj.sourceWidth * val / 100;

      // if (
      //   img.height > this.myLogo.canvasImgDefaultHeight ||
      //   img.width > this.myLogo.canvasImgDefaultWidth
      // ) {
      //   //缩小60%，太大了 多缩小
      //   if (
      //     img.height % this.myLogo.canvasImgDefaultHeight >= 2 ||
      //     img.width % this.myLogo.canvasImgDefaultWidth >= 2
      //   ) {
      //     img.height = img.height * 0.2;
      //     img.width = img.width * 0.2;
      //   } else {
      //     img.height = img.height * 0.6;
      //     img.width = img.width * 0.6;
      //   }
      // }
    }

    function onDragStart(event) {
      isDragEnd.value = true;
      const progressBox = document.querySelector('.progress');
      progressBox.addEventListener('mouseup', onDragEnd);
      progressBox.addEventListener('mousemove', onDrag);
    }
    function onDrag(event) {
      if (isDragEnd.value) {
        const progressBox = document.querySelector('.progress');
        const rect = progressBox.getBoundingClientRect();
        const width = rect.width;
        const offsetX = event.clientX - rect.left;
        let percentage = Math.round(offsetX / width * 100);
        percentage = Math.max(0, Math.min(percentage, 100));
        myLogo.fontSize = percentage;
        currentText.obj.fontSize = percentage;
      }
    }
    function onDragEnd() {
      isDragEnd.value = false;
    }
    function setBoxShadowColor(val) {
      currentText.obj.boxShadowColor = val;
    }
    function changeIsBglist(val) {
      if (!val) {
        myLogo.bg = '';
      }
    }
    function setBg(i) {
      if (myLogo.isBglist) {
        myLogo.bglist.push(i);
        let str = '';
        myLogo.bglist.forEach((element, index) => {
          if (index != myLogo.bglist.length - 1) {
            str += element + ',';
          } else {
            str += element;
          }
        });
        myLogo.bg = 'linear-gradient(' + myLogo.bgListDir + ',' + str + ')';
      } else {
        myLogo.bg = i;
      }
    }
    function setColorBg(i) {
      // console.log(currentText.obj);
      if (currentText.obj) {
        currentText.obj.bglist.push(i);
        let str = '';
        currentText.obj.bglist.forEach((element, index) => {
          if (index != currentText.obj.bglist.length - 1) {
            str += element + ',';
          } else {
            str += element;
          }
        });
        currentText.obj.bg = 'linear-gradient(' + currentText.obj.bgListDir + ',' + str + ')';
      }
    }
    function newPathD() {
      currentSvg.lList.push({
        l1: 0,
        l2: 0
      });
    }
    function removeSvgLlist(index) {
      currentSvg.lList.splice(index, 1);
    }
    function changeSvg() {
      let d = `M${currentSvg.m1},${currentSvg.m2}`;
      for (let o of currentSvg.lList) {
        let pathType = 'L';
        if (o.svgPathType == '曲线') {
          pathType = 'q';
        }
        d += `${pathType}${o.l1},${o.l2}`;
      }
      d += ' Z';
      currentSvg.d = d;
    }
    function removeBglistIndex(index) {
      myLogo.bglist.splice(index, 1);
      let str = '';
      myLogo.bglist.forEach((element, index) => {
        if (index != myLogo.bglist.length - 1) {
          str += element + ',';
        } else {
          str += element;
        }
      });
      myLogo.bg = 'linear-gradient(' + myLogo.bgListDir + ',' + str + ')';
    }
    function removeColorBglistIndex(index) {
      currentText.obj.bglist.splice(index, 1);
      let str = '';
      currentText.obj.bglist.forEach((element, index) => {
        if (index != currentText.obj.bglist.length - 1) {
          str += element + ',';
        } else {
          str += element;
        }
      });
      if (!str) {
        currentText.obj.bg = '';
      } else {
        currentText.obj.bg = 'linear-gradient(' + currentText.obj.bgListDir + ',' + str + ')';
      }
    }
    function yulan() {
      showImg.value = true;
    }
    // modern-screenshot 中有很多 api，用于生成不同的结果文件 比html2支持的好
    /**
     * exports.createContext = createContext;
    exports.destroyContext = destroyContext;
    exports.domToBlob = domToBlob;
    exports.domToCanvas = domToCanvas;
    exports.domToDataUrl = domToDataUrl;
    exports.domToForeignObjectSvg = domToForeignObjectSvg;
    exports.domToImage = domToImage;
    exports.domToJpeg = domToJpeg;
    exports.domToPixel = domToPixel;
    exports.domToPng = domToPng;
    exports.domToSvg = domToSvg;
    exports.domToWebp = domToWebp;
    exports.loadMedia = loadMedia;
    exports.waitUntilLoad = waitUntilLoad;
     */
    async function newImage() {
      let dom_content = document.querySelector('#content');
      if (dom_content) {
        const base64 = await domToPng(dom_content);
        const downloadElement = document.createElement('a');
        downloadElement.href = base64;
        downloadElement.download = 'newImg.png';
        document.body.appendChild(downloadElement);
        downloadElement.click();
        document.body.removeChild(downloadElement);
        successMsgBox('下载成功！');
        //return base64;
      }
    }

    async function newImageOld() {
      isNew.value = true;
      nextTick(() => {
        let _canvas = document.querySelector('#content');
        // 进行操作
        var canvas2 = document.createElement('canvas');
        var w = parseInt(window.getComputedStyle(_canvas).width);
        var h = parseInt(window.getComputedStyle(_canvas).height);
        //将canvas画布放大若干倍，然后盛放在较小的容器内，以破解模糊
        canvas2.width = w * 2;
        canvas2.height = h * 2;
        canvas2.style.width = w * 2 + 'px';
        canvas2.style.height = h * 2 + 'px';
        let ctxt = canvas2.getContext('2d');
        html2canvas(_canvas, {
          canvas: canvas2,
          dpi: 500,
          scale: 2,
          backgroundColor: null
        }).then(function (canvas) {
          isNew.value = false;

          // const ctx = canvas.getContext('2d');
          // ctx.shadowOffsetX = 5;
          // ctx.shadowOffsetY = 5;
          // ctx.shadowBlur = 4;
          // ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
          // // const url = canvas.toDataURL('image/png', 1)// 图片地址
          // ctx.drawImage(canvas, 5, 5); // 应用阴影偏移

          const image = canvas.toDataURL();
          // 获取生成的图片的url,replace("image/png", "image/octet-stream") 作用是告诉浏览器不要打开直接下载
          var imgUri = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
          currentNewImg.value = image;
          if (val) {
            successMsgBox('下载成功！');
            downloadNewImage(image);
          }
        });
      });
    }
    function downloadNewImage(image) {
      const downloadElement = document.createElement('a');
      downloadElement.href = image;
      downloadElement.download = 'newImg.png';
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
    }
    function removeAllImg() {
      myLogo.imgs = [];
    }
    function removeImg(index) {
      myLogo.imgs.splice(index, 1);
    }
    function topIndex(index) {
      let i = myLogo.imgs[index];
      let i1 = myLogo.imgs[index - 1];
      myLogo.imgs[index] = i1;
      myLogo.imgs[index - 1] = i;
    }
    function bottomIndex(index) {
      let i = myLogo.imgs[index];
      let i1 = myLogo.imgs[index + 1];
      myLogo.imgs[index] = i1;
      myLogo.imgs[index + 1] = i;
    }
    return (_ctx, _cache) => {
      const _component_myHeader = _resolveComponent("myHeader");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_col = _resolveComponent("el-col");
      const _component_View = _resolveComponent("View");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_color_picker = _resolveComponent("el-color-picker");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_Delete = _resolveComponent("Delete");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_edit = _resolveComponent("edit");
      const _component_Top = _resolveComponent("Top");
      const _component_Bottom = _resolveComponent("Bottom");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_a_modal = _resolveComponent("a-modal");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_myHeader, {
        type: "createImg"
      }), _createElementVNode("div", null, [_createVNode(_component_el_row, {
        style: {
          height: '100%'
        },
        class: "new-image"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 3,
          style: {
            "padding": "5px",
            "border-right": "1px solid var(--primary-grey-color)",
            "background": "var(--primary-grey-color)"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_input, {
            size: size.value,
            style: {
              "width": "60%",
              "margin-right": "10px"
            },
            placeholder: "科技，宠物、高清"
          }, null, 8, ["size"]), _createElementVNode("div", {
            class: "custom-btn",
            onClick: more
          }, "更多")]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
            class: _normalizeClass(["img-type", imgType.value == '高清' ? 'current' : '']),
            onClick: _cache[0] || (_cache[0] = $event => getImgType('高清'))
          }, "高清", 2), _createElementVNode("div", {
            class: _normalizeClass(["img-type", imgType.value == '动物' ? 'current' : '']),
            onClick: _cache[1] || (_cache[1] = $event => getImgType('动物'))
          }, "动物", 2), _createElementVNode("div", {
            class: _normalizeClass(["img-type", imgType.value == '科技' ? 'current' : '']),
            onClick: _cache[2] || (_cache[2] = $event => getImgType('科技'))
          }, "科技", 2), _createElementVNode("div", {
            class: _normalizeClass(["img-type", imgType.value == '风景' ? 'current' : '']),
            onClick: _cache[3] || (_cache[3] = $event => getImgType('风景'))
          }, "风景", 2), _createElementVNode("div", {
            class: _normalizeClass(["img-type", imgType.value == 'icon' ? 'current' : '']),
            onClick: _cache[4] || (_cache[4] = $event => getImgType('icon'))
          }, "icon", 2), _createElementVNode("div", {
            class: _normalizeClass(["img-type", imgType.value == '其他' ? 'current' : '']),
            onClick: _cache[5] || (_cache[5] = $event => getImgType('其他'))
          }, "其他", 2)]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(img_items.obj, (i, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              class: "fixed-images"
            }, [_createElementVNode("img", {
              src: i.access_path,
              style: {
                "width": "100%",
                "height": "100px"
              },
              onClick: $event => selectFixedImg(i.access_path)
            }, null, 8, _hoisted_4)]);
          }), 128))])), [[_directive_loading, loadingData.value]])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 17,
          style: {
            "margin-top": "10px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            style: _normalizeStyle([{
              "display": "flex",
              "justify-content": "center"
            }, {
              maxHeight: imageHeight.value,
              overflow: 'hidden'
            }])
          }, [_createElementVNode("div", {
            style: _normalizeStyle({
              border: !myLogo.bg ? '1px dashed  var(--primary-color)' : '',
              height: `${myLogo.canvasImgDefaultHeight}px`,
              width: `${myLogo.canvasImgDefaultWidth}px`
            })
          }, [_createElementVNode("div", {
            style: _normalizeStyle({
              transform: myLogo.skew ? `skew(${myLogo.skew}deg, 0)` : '' /* 第一个值是X轴倾斜，第二个值是Y轴倾斜 */,

              borderRadius: myLogo.borderRadius ? `${myLogo.borderRadius}px` : '',
              position: 'relative',
              height: '100%',
              width: '100%',
              background: myLogo.bg,
              overflow: 'hidden' //元素超出隐藏
            })
          }, [activeName.value == 'svg绘图' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(), _createElementBlock("svg", {
            width: currentSvg.width,
            height: currentSvg.height,
            xmlns: "http://www.w3.org/2000/svg"
          }, [_createElementVNode("path", {
            d: currentSvg.d,
            fill: currentSvg.fill,
            stroke: currentSvg.stroke,
            "stroke-width": "2"
          }, null, 8, _hoisted_7)], 8, _hoisted_6))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(myLogo.texts, (text, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "my-huabu",
              draggable: "true",
              onDragstart: $event => dragstart($event, text),
              onDragend: $event => dragend($event, text),
              onClick: $event => gotoText(text, index),
              key: index,
              style: _normalizeStyle({
                border: isNew.value ? text.borderSize && text.borderColor ? `${text.borderSize}px ${text.borderColor} solid` : 'none' : text.id == currentText.obj.id ? text.borderSize && text.borderColor ? `${text.borderSize}px ${text.borderColor} solid` : '1px dashed #fff' : text.borderSize && text.borderColor ? `${text.borderSize}px ${text.borderColor} solid` : 'none',
                position: 'absolute',
                zIndex: 999,
                transform: text.transformRotate ? 'rotate(' + `${text.transformRotate}deg` + ')' : '',
                top: `${text.top}px`,
                left: `${text.left}px`,
                borderRadius: text.borderRadius ? `${text.borderRadius}px` : '',
                writingMode: text.isFlex == '竖排' ? 'vertical-rl' : '',
                boxShadow: text.isBoxShadow ? `${text.boxShadowColor}  ${text.boxShadowTop}px ${text.boxShadowLeft}px ${text.boxShadowBottom}px` : ''
              })
            }, [text.isTextarea ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
              key: 0,
              "onUpdate:modelValue": $event => text.inputContent = $event,
              style: _normalizeStyle({
                writingMode: text.isFlex == '竖排' ? 'vertical-rl' : '',
                width: text.isFlex == '竖排' ? '' : `${text.fontSize * text.inputContent.length + 10}px`,
                //横排时文字宽度的10倍
                fontFamily: text.fontFamily,
                color: text.isXuncai ? 'transparent' : text.color,
                background: text.isXuncai ? text.bg : text.textBg ? text.textBg : '',
                webkitBackgroundClip: text.bg ? 'text' : '',
                fontSize: `${text.fontSize}px`,
                paddingTop: text.textTopPadding ? `${text.textTopPadding}px` : '',
                paddingRight: text.textRightPadding ? `${text.textRightPadding}px` : '',
                paddingLeft: text.textLeftPadding ? `${text.textLeftPadding}px` : '',
                paddingBottom: text.textBottomPadding ? `${text.textBottomPadding}px` : '',
                fontStyle: text.isItalic == '是' ? 'italic' : '',
                fontWeight: text.fontWeight ? text.fontWeight : ''
              })
            }, null, 12, _hoisted_9)), [[_vModelText, text.inputContent]]) : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              "onUpdate:modelValue": $event => text.inputContent = $event,
              style: _normalizeStyle({
                writingMode: text.isFlex == '竖排' ? 'vertical-rl' : '',
                width: text.isFlex == '竖排' ? '' : `${text.fontSize * text.inputContent.length + 5}px`,
                //横排时文字宽度的10倍
                fontFamily: text.fontFamily,
                color: text.isXuncai ? 'transparent' : text.color,
                background: text.isXuncai ? text.bg : text.textBg ? text.textBg : 'transparent',
                webkitBackgroundClip: text.bg ? 'text' : '',
                fontSize: `${text.fontSize}px`,
                paddingTop: text.textTopPadding ? `${text.textTopPadding}px` : '',
                paddingRight: text.textRightPadding ? `${text.textRightPadding}px` : '',
                paddingLeft: text.textLeftPadding ? `${text.textLeftPadding}px` : '',
                paddingBottom: text.textBottomPadding ? `${text.textBottomPadding}px` : '',
                fontStyle: text.isItalic == '是' ? 'italic' : '',
                fontWeight: text.fontWeight ? text.fontWeight : ''
              })
            }, null, 12, _hoisted_10)), [[_vModelText, text.inputContent]])], 44, _hoisted_8);
          }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myLogo.imgs, (i, index) => {
            return _openBlock(), _createElementBlock("div", {
              key: index,
              draggable: "true",
              onClick: $event => gotoImg($event, i),
              onDragstart: $event => dragstart($event, i),
              onDragend: $event => dragend($event, i),
              class: _normalizeClass(i.isMask ? logoImgs.value : ''),
              style: _normalizeStyle({
                border: isNew.value ? '' : '1px dashed rgba(0, 0, 0, 0.12)',
                cursor: isFill.value ? 'url(https://itlifetime.com/resources/xiaochengxu/1711466115578.png)' : 'crosshair',
                position: 'absolute',
                top: `${i.top}px`,
                left: `${i.left}px`,
                transform: i.transform3d ? `perspective(${i.perspective3d}px) rotate3d(${i.x3d},${i.y3d},${i.z3d},${i.deg3d}deg)` : i.transformRotate ? 'rotate(' + `${i.transformRotate}deg` + ')' : '',
                width: `${i.width}px`,
                height: `${i.height}px`
              })
            }, [_createElementVNode("img", {
              src: i.src,
              style: _normalizeStyle({
                filter: i.grayscale ? `grayscale(${i.grayscale}%)` : i.filterBlur ? `blur(${i.filterBlur}px)` : i.brightness ? `brightness(${i.brightness})` : i.sepia ? `sepia(${i.sepia}%)` : i.saturate ? `saturate(${i.saturate}%)` : '',
                width: '100%',
                height: '100%',
                opacity: i.opacity ? i.opacity / 10 : ''
              })
            }, null, 12, _hoisted_12)], 46, _hoisted_11);
          }), 128))], 4)], 4)], 4)]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 4,
          style: {
            "height": "calc(100vh - 45px)",
            "padding": "5px",
            "text-align": "left",
            "border-left": "1px solid var(--primary-grey-color)",
            "background": "var(--primary-grey-color)"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
            class: "custom-btn img-view",
            style: {
              "background": "#a18cd1 !important"
            },
            onClick: yulan
          }, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_View)]),
            _: 1
          }), _hoisted_14])]), _createElementVNode("div", null, [_createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => activeName.value = $event),
            class: "demo-tabs",
            onTabClick: _ctx.newImageTabClick
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: "画布",
              name: "画布"
            }), _createVNode(_component_el_tab_pane, {
              label: "文字",
              name: "文字"
            }), _createVNode(_component_el_tab_pane, {
              label: "图片",
              name: "图片"
            }), _createVNode(_component_el_tab_pane, {
              label: "svg绘图",
              name: "svg绘图"
            })]),
            _: 1
          }, 8, ["modelValue", "onTabClick"])]), _createElementVNode("div", {
            style: _normalizeStyle({
              maxHeight: formMaxHeight.value,
              overflow: 'auto',
              padding: '5px'
            })
          }, [activeName.value == '画布' ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            "label-width": "120px",
            "label-position": "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_15]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_select, {
                onChange: changeImageSize,
                modelValue: currentImageSize.value,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => currentImageSize.value = $event),
                size: size.value
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imageSizes, (i, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: i.title,
                    value: i.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue", "size"])]), _createElementVNode("div", null, [_createVNode(_component_el_input_number, {
                size: size.value,
                min: 1,
                style: {
                  "width": "45%",
                  "margin-right": "5%"
                },
                modelValue: myLogo.canvasImgDefaultWidth,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => myLogo.canvasImgDefaultWidth = $event),
                placeholder: "请输入宽度"
              }, null, 8, ["size", "modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "45%"
                },
                modelValue: myLogo.canvasImgDefaultHeight,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => myLogo.canvasImgDefaultHeight = $event),
                placeholder: "请输入高度"
              }, null, 8, ["size", "modelValue"])])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_17]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedColor, (i, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: $event => setBg(i),
                  class: "fixed-font-color",
                  style: _normalizeStyle({
                    background: i ? i : 'none',
                    border: myLogo.bg == i ? '1px solid red' : 'none'
                  })
                }, null, 12, _hoisted_18);
              }), 128)), _createVNode(_component_el_color_picker, {
                modelValue: myLogo.bg,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => myLogo.bg = $event),
                onChange: _ctx.addDefindColor
              }, null, 8, ["modelValue", "onChange"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_19]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_20, [_createVNode(_component_el_switch, {
                size: size.value,
                modelValue: myLogo.isBglist,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => myLogo.isBglist = $event),
                onChange: changeIsBglist,
                "active-text": "是",
                "inactive-text": "否",
                "active-color": "#13ce66",
                "inactive-color": "#ff4949",
                "active-value": true,
                "inactive-value": false
              }, null, 8, ["size", "modelValue"])]), _createElementVNode("div", _hoisted_21, [myLogo.isBglist ? (_openBlock(), _createBlock(_component_el_radio_group, {
                key: 0,
                size: "meduim",
                modelValue: myLogo.bgListDir,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => myLogo.bgListDir = $event),
                onChange: _ctx.setNewBg
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: "to top"
                }, {
                  default: _withCtx(() => [_createTextVNode("从上到下")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: "to right"
                }, {
                  default: _withCtx(() => [_createTextVNode("从左到右")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: "to bottom right"
                }, {
                  default: _withCtx(() => [_createTextVNode("对角")]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue", "onChange"])) : _createCommentVNode("", true)]), myLogo.isBglist ? (_openBlock(), _createElementBlock("div", _hoisted_22, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myLogo.bglist, (i, index) => {
                return _openBlock(), _createBlock(_component_el_row, {
                  key: index
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 8,
                    class: "fixed-font-color",
                    style: _normalizeStyle({
                      marginBotton: '5px',
                      background: i ? i : 'none',
                      border: myLogo.bg == i ? '1px solid red' : 'none'
                    })
                  }, null, 8, ["style"]), _createVNode(_component_el_col, {
                    span: 4
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, {
                      onClick: $event => removeBglistIndex(index)
                    }, {
                      default: _withCtx(() => [_createVNode(_component_Delete)]),
                      _: 2
                    }, 1032, ["onClick"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024);
              }), 128))])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_23]),
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                size: size.value,
                modelValue: myLogo.borderRadius,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => myLogo.borderRadius = $event),
                placeholder: "边角弧度"
              }, null, 8, ["size", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_24]),
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                size: size.value,
                modelValue: myLogo.skew,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => myLogo.skew = $event),
                placeholder: "边角倾斜"
              }, null, 8, ["size", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_25]),
              default: _withCtx(() => [_createVNode(_component_el_switch, {
                size: size.value,
                modelValue: isDrag.value,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => isDrag.value = $event),
                "active-text": "是",
                "inactive-text": "否",
                "active-color": "#13ce66",
                "inactive-color": "#ff4949",
                "active-value": true,
                "inactive-value": false
              }, null, 8, ["size", "modelValue"])]),
              _: 1
            })]),
            _: 1
          })) : activeName.value == '文字' ? (_openBlock(), _createBlock(_component_el_form, {
            key: 1,
            "label-width": "120px",
            "label-position": "top"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_button, {
              size: size.value,
              icon: "plus",
              onClick: _cache[16] || (_cache[16] = $event => newText(0)),
              type: "plain"
            }, {
              default: _withCtx(() => [_createTextVNode("文字")]),
              _: 1
            }, 8, ["size"]), _createVNode(_component_el_button, {
              size: size.value,
              icon: "plus",
              onClick: _cache[17] || (_cache[17] = $event => newText(1)),
              type: "plain"
            }, {
              default: _withCtx(() => [_createTextVNode("文本")]),
              _: 1
            }, 8, ["size"]), _createVNode(_component_el_button, {
              size: size.value,
              icon: "lock",
              onClick: _cache[18] || (_cache[18] = $event => currentText.obj.lockDrag = !currentText.obj.lockDrag),
              type: "plain"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(currentText.obj.lockDrag ? '解锁' : '锁定'), 1)]),
              _: 1
            }, 8, ["size"]), _createVNode(_component_el_button, {
              onClick: deleteElement,
              disabled: !currentText.obj && !currentImg,
              type: "danger",
              size: size.value
            }, {
              default: _withCtx(() => [_createTextVNode("撤销")]),
              _: 1
            }, 8, ["disabled", "size"])]), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_27]),
              default: _withCtx(() => [_createVNode(_component_el_input, {
                size: size.value,
                type: "textarea",
                modelValue: currentText.obj.inputContent,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => currentText.obj.inputContent = $event)
              }, null, 8, ["size", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_28]),
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                size: size.value,
                modelValue: currentText.obj.isFlex,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => currentText.obj.isFlex = $event),
                label: "横排"
              }, null, 8, ["size", "modelValue"]), _createVNode(_component_el_radio, {
                size: size.value,
                modelValue: currentText.obj.isFlex,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => currentText.obj.isFlex = $event),
                label: "竖排"
              }, null, 8, ["size", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_29]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                size: size.value,
                onChange: changeFont,
                modelValue: currentTtlIndex.value,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => currentTtlIndex.value = $event),
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}'
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ttlList, (i, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: i.name,
                    value: index
                  }, {
                    default: _withCtx(() => [_createElementVNode("span", {
                      style: _normalizeStyle({
                        fontSize: '18px',
                        color: _unref(theme).black,
                        fontFamily: i.fontFamily
                      }),
                      class: "my-font"
                    }, _toDisplayString(i.name), 5)]),
                    _: 2
                  }, 1032, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["size", "modelValue", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_30]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedColor, (i, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: $event => currentText.obj.color = i,
                  class: "fixed-font-color",
                  style: _normalizeStyle({
                    background: i ? i : 'none',
                    border: currentText.obj.color == i ? '1px solid red' : 'none'
                  })
                }, null, 12, _hoisted_31);
              }), 128)), _createVNode(_component_el_color_picker, {
                modelValue: currentText.obj.color,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => currentText.obj.color = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_32]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createVNode(_component_el_switch, {
                size: size.value,
                disabled: !currentText.obj || !currentText.obj.id,
                modelValue: currentText.obj.isXuncai,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => currentText.obj.isXuncai = $event),
                "active-text": "开启",
                "inactive-text": "关闭",
                "active-color": "#13ce66",
                "inactive-color": "#ff4949",
                "active-value": true,
                "inactive-value": false
              }, null, 8, ["size", "disabled", "modelValue"])]), currentText.obj.isXuncai ? (_openBlock(), _createElementBlock("div", _hoisted_34, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedColor, (i, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: $event => setColorBg(i),
                  class: "fixed-font-color",
                  style: _normalizeStyle({
                    background: i ? i : 'none',
                    border: currentText.obj.color == i ? '1px solid red' : 'none'
                  })
                }, null, 12, _hoisted_35);
              }), 128)), _createVNode(_component_el_color_picker, {
                onChange: setColorBg
              }), _createElementVNode("div", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentText.obj.bglist, (i, index) => {
                return _openBlock(), _createBlock(_component_el_row, {
                  key: index
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 8,
                    class: "fixed-font-color",
                    style: _normalizeStyle({
                      marginBotton: '5px',
                      background: i ? i : 'none',
                      border: myLogo.bg == i ? '1px solid red' : 'none'
                    })
                  }, null, 8, ["style"]), _createVNode(_component_el_col, {
                    span: 4
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, {
                      onClick: $event => removeColorBglistIndex(index)
                    }, {
                      default: _withCtx(() => [_createVNode(_component_Delete)]),
                      _: 2
                    }, 1032, ["onClick"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024);
              }), 128))])])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_37]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_38, [_createVNode(_component_el_switch, {
                size: size.value,
                disabled: !currentText.obj || !currentText.obj.id,
                modelValue: currentText.obj.isBoxShadow,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => currentText.obj.isBoxShadow = $event),
                "active-text": "开启",
                "inactive-text": "关闭",
                "active-color": "#13ce66",
                "inactive-color": "#ff4949",
                "active-value": true,
                "inactive-value": false
              }, null, 8, ["size", "disabled", "modelValue"])]), currentText.obj.isBoxShadow ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedColor, (i, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: $event => setBoxShadowColor(i),
                  class: "fixed-font-color",
                  style: _normalizeStyle({
                    background: i ? i : 'none',
                    border: currentText.obj.boxShadowColor == i ? '1px solid red' : 'none'
                  })
                }, null, 12, _hoisted_41);
              }), 128)), _createVNode(_component_el_color_picker, {
                onChange: setBoxShadowColor
              })]), _createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                style: {
                  "width": "100%"
                },
                modelValue: currentText.obj.boxShadowTop,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => currentText.obj.boxShadowTop = $event),
                placeholder: "上阴影"
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                style: {
                  "width": "100%"
                },
                modelValue: currentText.obj.boxShadowLeft,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => currentText.obj.boxShadowLeft = $event),
                placeholder: "左阴影"
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                style: {
                  "width": "100%"
                },
                modelValue: currentText.obj.boxShadowBottom,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => currentText.obj.boxShadowBottom = $event),
                placeholder: "下阴影"
              }, null, 8, ["size", "disabled", "modelValue"])])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_42]),
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                min: 1,
                style: {
                  "width": "50%"
                },
                max: 300,
                modelValue: currentText.obj.fontSize,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = $event => currentText.obj.fontSize = $event),
                placeholder: "25"
              }, null, 8, ["size", "disabled", "modelValue"]), _createElementVNode("div", {
                class: "progress",
                onMousedown: onDragStart,
                style: {
                  "width": "50%"
                }
              }, [_createVNode(_component_el_progress, {
                size: size.value,
                style: {
                  "margin-top": "12px",
                  "cursor": "pointer"
                },
                percentage: currentText.obj.fontSize
              }, null, 8, ["size", "percentage"])], 32)]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_43, _createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                style: {
                  "width": "100%"
                },
                modelValue: currentText.obj.fontWeight,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => currentText.obj.fontWeight = $event),
                placeholder: "粗细比例"
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_44, _createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                style: {
                  "width": "100%"
                },
                modelValue: currentText.obj.transformRotate,
                "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => currentText.obj.transformRotate = $event),
                placeholder: "旋转角度"
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_45]),
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                min: 0,
                style: {
                  "width": "100%"
                },
                modelValue: currentText.obj.borderSize,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => currentText.obj.borderSize = $event),
                placeholder: "边框尺寸"
              }, null, 8, ["size", "disabled", "modelValue"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedColor, (i, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: $event => currentText.obj.borderColor = i,
                  class: "fixed-font-color",
                  style: _normalizeStyle({
                    background: i ? i : 'none',
                    border: currentText.obj.borderColor == i ? '1px solid red' : 'none'
                  })
                }, null, 12, _hoisted_46);
              }), 128)), _createVNode(_component_el_color_picker, {
                modelValue: currentText.obj.borderColor,
                "onUpdate:modelValue": _cache[33] || (_cache[33] = $event => currentText.obj.borderColor = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_47]),
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                min: 0,
                style: {
                  "width": "100%"
                },
                modelValue: currentText.obj.borderRadius,
                "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => currentText.obj.borderRadius = $event),
                placeholder: "边框弧度"
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_48]),
              default: _withCtx(() => [_createVNode(_component_el_select, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                onChange: changeTextPosition,
                modelValue: currentText.obj.textPosition,
                "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => currentText.obj.textPosition = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  lable: "居中",
                  value: "居中"
                }), _createVNode(_component_el_option, {
                  lable: "左上角",
                  value: "左上角"
                }), _createVNode(_component_el_option, {
                  lable: "右上角",
                  value: "右上角"
                }), _createVNode(_component_el_option, {
                  lable: "右下角",
                  value: "右下角"
                }), _createVNode(_component_el_option, {
                  lable: "左下角",
                  value: "左下角"
                })]),
                _: 1
              }, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                style: {
                  "width": "100%"
                },
                modelValue: currentText.obj.top,
                "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => currentText.obj.top = $event),
                placeholder: "距离上面"
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                style: {
                  "width": "100%"
                },
                modelValue: currentText.obj.left,
                "onUpdate:modelValue": _cache[37] || (_cache[37] = $event => currentText.obj.left = $event),
                placeholder: "距离左面"
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "背景"
            }, {
              label: _withCtx(() => [_hoisted_49]),
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedColor, (i, index) => {
                return _openBlock(), _createElementBlock("div", {
                  key: index,
                  onClick: $event => currentText.obj.textBg = i,
                  class: "fixed-font-color",
                  style: _normalizeStyle({
                    background: i ? i : 'none',
                    border: currentText.obj.textBg == i ? '1px solid red' : 'none'
                  })
                }, null, 12, _hoisted_50);
              }), 128)), _createVNode(_component_el_color_picker, {
                modelValue: currentText.obj.textBg,
                "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => currentText.obj.textBg = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_51]),
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "100%"
                },
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                modelValue: currentText.obj.textTopPadding,
                "onUpdate:modelValue": _cache[39] || (_cache[39] = $event => currentText.obj.textTopPadding = $event),
                placeholder: "上边距"
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "100%"
                },
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                modelValue: currentText.obj.textLeftPadding,
                "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => currentText.obj.textLeftPadding = $event),
                placeholder: "左边距"
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "100%"
                },
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                modelValue: currentText.obj.textRightPadding,
                "onUpdate:modelValue": _cache[41] || (_cache[41] = $event => currentText.obj.textRightPadding = $event),
                placeholder: "右边距"
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "100%"
                },
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}',
                modelValue: currentText.obj.textBottomPadding,
                "onUpdate:modelValue": _cache[42] || (_cache[42] = $event => currentText.obj.textBottomPadding = $event),
                placeholder: "底内边距"
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_52]),
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                modelValue: currentText.obj.isItalic,
                "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => currentText.obj.isItalic = $event),
                label: "是",
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}'
              }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_el_radio, {
                modelValue: currentText.obj.isItalic,
                "onUpdate:modelValue": _cache[44] || (_cache[44] = $event => currentText.obj.isItalic = $event),
                label: "否",
                disabled: !currentText.obj || JSON.stringify(currentText.obj) == '{}'
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          })) : activeName.value == '图片' ? (_openBlock(), _createElementBlock("div", _hoisted_53, [_createVNode(_component_el_tabs, {
            size: size.value,
            modelValue: imgTool.value,
            "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => imgTool.value = $event),
            class: "demo-tabs"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
              label: "图片列表",
              name: "图片列表"
            }), _createVNode(_component_el_tab_pane, {
              label: "工具",
              name: "工具"
            })]),
            _: 1
          }, 8, ["size", "modelValue"]), imgTool.value == '图片列表' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_54, [_createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                icon: "delete",
                onClick: removeAllImg,
                disabled: !myLogo.imgs || myLogo.imgs.length == 0
              }, {
                default: _withCtx(() => [_createTextVNode(" 清空图片 ")]),
                _: 1
              }, 8, ["disabled"])]), _createElementVNode("div", null, [_createElementVNode("input", {
                type: "file",
                id: "uploads",
                style: {
                  "clip": "rect(0 0 0 0)"
                },
                accept: "image/webp,image/png, image/jpeg, image/gif, image/jpg",
                onChange: _cache[46] || (_cache[46] = $event => selectBgImg($event))
              }, null, 32)])]),
              _: 1
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myLogo.imgs, (i, index) => {
              return _openBlock(), _createElementBlock("div", {
                key: index,
                style: _normalizeStyle({
                  border: currentImg.obj && currentImg.obj.id == i.id ? '1px solid var(--primary-color)' : '',
                  borderRadius: '5px',
                  marginTop: '10px'
                })
              }, [_createVNode(_component_el_icon, {
                onClick: $event => gotoImgTool(i),
                style: {
                  "cursor": "pointer"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_edit)]),
                _: 2
              }, 1032, ["onClick"]), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "margin-right": "3px",
                  "width": "40%"
                },
                modelValue: i.width,
                "onUpdate:modelValue": $event => i.width = $event,
                placeholder: "请输入宽度"
              }, null, 8, ["size", "modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "40%"
                },
                modelValue: i.height,
                "onUpdate:modelValue": $event => i.height = $event,
                placeholder: "请输入高度"
              }, null, 8, ["size", "modelValue", "onUpdate:modelValue"]), index != 0 ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 0,
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => topIndex(index)
              }, {
                default: _withCtx(() => [_createVNode(_component_Top)]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), index != myLogo.imgs.length - 1 && myLogo.imgs.length > 1 ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 1,
                style: {
                  "cursor": "pointer"
                },
                onClick: $event => bottomIndex(index)
              }, {
                default: _withCtx(() => [_createVNode(_component_Bottom)]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_icon, {
                onClick: $event => removeImg(index),
                style: {
                  "cursor": "pointer"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_Delete)]),
                _: 2
              }, 1032, ["onClick"])], 4);
            }), 128))]),
            _: 1
          })) : imgTool.value == '工具' ? (_openBlock(), _createBlock(_component_el_form, {
            key: 1,
            "label-width": "120px",
            "label-position": "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                size: size.value,
                disabled: !currentImg.obj.id,
                type: "danger",
                icon: "delete",
                onClick: cancelHandleImg
              }, {
                default: _withCtx(() => [_createTextVNode("撤销")]),
                _: 1
              }, 8, ["size", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_55, _createElementVNode("div", _hoisted_56, [_createVNode(_component_el_switch, {
                size: size.value,
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: isQuse.value,
                "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => isQuse.value = $event),
                onChange: changeQuse,
                "active-text": "开启",
                "inactive-text": "关闭",
                "active-color": "#13ce66",
                "inactive-color": "#ff4949",
                "active-value": true,
                "inactive-value": false
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_color_picker, {
                modelValue: imgColor.value,
                "onUpdate:modelValue": _cache[48] || (_cache[48] = $event => imgColor.value = $event),
                disabled: !isQuse.value
              }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_el_button, {
                size: size.value,
                text: "",
                link: "",
                disabled: !imgColor.value,
                onClick: _cache[49] || (_cache[49] = $event => copyImgBase64(imgColor.value))
              }, {
                default: _withCtx(() => [_createTextVNode("复制")]),
                _: 1
              }, 8, ["size", "disabled"])])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_57, _createElementVNode("div", _hoisted_58, [_createVNode(_component_el_switch, {
                size: size.value,
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: isFill.value,
                "onUpdate:modelValue": _cache[50] || (_cache[50] = $event => isFill.value = $event),
                onChange: changeFill,
                "active-text": "开启",
                "inactive-text": "关闭",
                "active-color": "#13ce66",
                "inactive-color": "#ff4949",
                "active-value": true,
                "inactive-value": false
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_color_picker, {
                modelValue: fillColor.value,
                "onUpdate:modelValue": _cache[51] || (_cache[51] = $event => fillColor.value = $event),
                disabled: !isFill.value
              }, null, 8, ["modelValue", "disabled"])])]),
              _: 1
            }), isFill.value ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0
            }, {
              default: _withCtx(() => [_hoisted_59, _createElementVNode("div", _hoisted_60, [_createVNode(_component_el_radio_group, {
                size: size.value,
                modelValue: canType.value,
                "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => canType.value = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: "circle"
                }, {
                  default: _withCtx(() => [_createTextVNode("圆形")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: "spuare"
                }, {
                  default: _withCtx(() => [_createTextVNode("方形")]),
                  _: 1
                })]),
                _: 1
              }, 8, ["size", "modelValue"])])]),
              _: 1
            })) : _createCommentVNode("", true), isFill.value ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 1
            }, {
              default: _withCtx(() => [_hoisted_61, _createElementVNode("div", _hoisted_62, [_createVNode(_component_el_input_number, {
                size: size.value,
                min: 10,
                modelValue: arcSize.value,
                "onUpdate:modelValue": _cache[53] || (_cache[53] = $event => arcSize.value = $event),
                placeholder: "请输入比例"
              }, null, 8, ["size", "modelValue"])])]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_63, _createVNode(_component_el_radio_group, {
                size: size.value,
                onChange: doResizeImg,
                modelValue: currentImg.obj.bili,
                "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => currentImg.obj.bili = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: 100,
                  disabled: !currentImg.obj || !currentImg.obj.id
                }, {
                  default: _withCtx(() => [_createTextVNode("完整大小")]),
                  _: 1
                }, 8, ["disabled"]), _createVNode(_component_el_radio, {
                  label: 50,
                  disabled: !currentImg.obj || !currentImg.obj.id
                }, {
                  default: _withCtx(() => [_createTextVNode("50%")]),
                  _: 1
                }, 8, ["disabled"]), _createVNode(_component_el_radio, {
                  label: 10,
                  disabled: !currentImg.obj || !currentImg.obj.id
                }, {
                  default: _withCtx(() => [_createTextVNode("10%")]),
                  _: 1
                }, 8, ["disabled"])]),
                _: 1
              }, 8, ["size", "modelValue"]), _createVNode(_component_el_input_number, {
                size: size.value,
                min: 10,
                onInput: doResizeImg,
                modelValue: currentImg.obj.bili,
                "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => currentImg.obj.bili = $event),
                placeholder: "请输入比例"
              }, null, 8, ["size", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_64, _createVNode(_component_el_switch, {
                size: size.value,
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.isMask,
                "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => currentImg.obj.isMask = $event),
                "active-text": "开启",
                "inactive-text": "关闭",
                "active-color": "#13ce66",
                "inactive-color": "#ff4949",
                "active-value": true,
                "inactive-value": false
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_65, _createVNode(_component_el_input_number, {
                style: {
                  "width": "65%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id || currentImg.obj.transform3d,
                modelValue: currentImg.obj.transformRotate,
                "onUpdate:modelValue": _cache[57] || (_cache[57] = $event => currentImg.obj.transformRotate = $event),
                placeholder: "旋转角度"
              }, null, 8, ["disabled", "modelValue"]), _hoisted_66, _createVNode(_component_el_switch, {
                size: size.value,
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.transform3d,
                "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => currentImg.obj.transform3d = $event),
                "active-text": "开启",
                "inactive-text": "关闭",
                "active-color": "#13ce66",
                "inactive-color": "#ff4949",
                "active-value": true,
                "inactive-value": false
              }, null, 8, ["size", "disabled", "modelValue"]), currentImg.obj.transform3d ? (_openBlock(), _createElementBlock("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createTextVNode(" 视距: "), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "60%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.perspective3d,
                "onUpdate:modelValue": _cache[59] || (_cache[59] = $event => currentImg.obj.perspective3d = $event),
                placeholder: "视距"
              }, null, 8, ["size", "disabled", "modelValue"])]), _createElementVNode("div", _hoisted_69, [_createTextVNode(" x轴: "), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "60%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.x3d,
                "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => currentImg.obj.x3d = $event),
                placeholder: "x轴"
              }, null, 8, ["size", "disabled", "modelValue"])]), _createElementVNode("div", _hoisted_70, [_createTextVNode(" y轴: "), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "60%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.y3d,
                "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => currentImg.obj.y3d = $event),
                placeholder: "y轴"
              }, null, 8, ["size", "disabled", "modelValue"])]), _createElementVNode("div", _hoisted_71, [_createTextVNode(" z轴: "), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "60%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.z3d,
                "onUpdate:modelValue": _cache[62] || (_cache[62] = $event => currentImg.obj.z3d = $event),
                placeholder: "z轴"
              }, null, 8, ["size", "disabled", "modelValue"])]), _createElementVNode("div", null, [_createTextVNode(" 旋转角度: "), _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "65%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.deg3d,
                "onUpdate:modelValue": _cache[63] || (_cache[63] = $event => currentImg.obj.deg3d = $event),
                placeholder: "旋转角度"
              }, null, 8, ["size", "disabled", "modelValue"])])])) : _createCommentVNode("", true)]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_72, _createVNode(_component_el_input_number, {
                max: 100,
                size: size.value,
                style: {
                  "width": "65%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.grayscale,
                "onUpdate:modelValue": _cache[64] || (_cache[64] = $event => currentImg.obj.grayscale = $event),
                placeholder: "灰度"
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Delete, {
                  onClick: _cache[65] || (_cache[65] = $event => currentImg.obj.grayscale = '')
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_73, _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "65%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.filterBlur,
                "onUpdate:modelValue": _cache[66] || (_cache[66] = $event => currentImg.obj.filterBlur = $event),
                placeholder: "模糊"
              }, null, 8, ["size", "disabled", "modelValue"]), _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Delete, {
                  onClick: _ctx.clearFilterbulur
                }, null, 8, ["onClick"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_74, _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "65%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.opacity,
                "onUpdate:modelValue": _cache[67] || (_cache[67] = $event => currentImg.obj.opacity = $event),
                placeholder: "透明度"
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_75, _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "65%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.brightness,
                "onUpdate:modelValue": _cache[68] || (_cache[68] = $event => currentImg.obj.brightness = $event),
                placeholder: "亮度"
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_76, _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "65%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.sepia,
                "onUpdate:modelValue": _cache[69] || (_cache[69] = $event => currentImg.obj.sepia = $event),
                placeholder: "复古"
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_hoisted_77, _createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "65%"
                },
                disabled: !currentImg.obj || !currentImg.obj.id,
                modelValue: currentImg.obj.saturate,
                "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => currentImg.obj.saturate = $event),
                placeholder: "饱和"
              }, null, 8, ["size", "disabled", "modelValue"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)])) : activeName.value == 'svg绘图' ? (_openBlock(), _createElementBlock("div", _hoisted_78, [_createVNode(_component_el_form, {
            "label-width": "120px",
            "label-position": "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_79]),
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                onInput: changeSvg,
                size: size.value,
                min: 1,
                style: {
                  "width": "45%",
                  "margin-right": "5%"
                },
                modelValue: currentSvg.width,
                "onUpdate:modelValue": _cache[71] || (_cache[71] = $event => currentSvg.width = $event),
                placeholder: "请输入宽度"
              }, null, 8, ["size", "modelValue"]), _createVNode(_component_el_input_number, {
                onInput: changeSvg,
                size: size.value,
                style: {
                  "width": "45%"
                },
                modelValue: currentSvg.height,
                "onUpdate:modelValue": _cache[72] || (_cache[72] = $event => currentSvg.height = $event),
                placeholder: "请输入高度"
              }, null, 8, ["size", "modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createElementVNode("div", null, [_createVNode(_component_el_tag, {
            class: "custom-btn light"
          }, {
            default: _withCtx(() => [_createTextVNode("路径")]),
            _: 1
          }), _createVNode(_component_el_form, {
            "label-width": "120px",
            "label-position": "top"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_80]),
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                onInput: changeSvg,
                size: size.value,
                style: {
                  "width": "45%"
                },
                modelValue: currentSvg.m1,
                "onUpdate:modelValue": _cache[73] || (_cache[73] = $event => currentSvg.m1 = $event),
                placeholder: "起始坐标"
              }, null, 8, ["size", "modelValue"]), _createVNode(_component_el_input_number, {
                onInput: changeSvg,
                size: size.value,
                style: {
                  "width": "45%"
                },
                modelValue: currentSvg.m2,
                "onUpdate:modelValue": _cache[74] || (_cache[74] = $event => currentSvg.m2 = $event),
                placeholder: "起始坐标"
              }, null, 8, ["size", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_81]),
              default: _withCtx(() => [_createElementVNode("div", {
                class: "custom-btn",
                onClick: newPathD
              }, "+ 新增移动路径"), _createElementVNode("div", _hoisted_82, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentSvg.lList, (i, index) => {
                return _openBlock(), _createBlock(_component_el_row, {
                  key: index
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_col, {
                    span: 16
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input_number, {
                      onInput: changeSvg,
                      size: size.value,
                      style: {
                        "width": "45%"
                      },
                      modelValue: i.l1,
                      "onUpdate:modelValue": $event => i.l1 = $event,
                      placeholder: "移动坐标"
                    }, null, 8, ["size", "modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_input_number, {
                      onInput: changeSvg,
                      size: size.value,
                      style: {
                        "width": "45%"
                      },
                      modelValue: i.l2,
                      "onUpdate:modelValue": $event => i.l2 = $event,
                      placeholder: "移动坐标"
                    }, null, 8, ["size", "modelValue", "onUpdate:modelValue"])]),
                    _: 2
                  }, 1024), _createVNode(_component_el_col, {
                    span: 6
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_select, {
                      onChange: changeSvg,
                      size: size.value,
                      modelValue: i.svgPathType,
                      "onUpdate:modelValue": $event => i.svgPathType = $event
                    }, {
                      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(svgPathTypeList, (k, index1) => {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: index1,
                          label: k,
                          value: k
                        }, null, 8, ["label", "value"]);
                      }), 128))]),
                      _: 2
                    }, 1032, ["size", "modelValue", "onUpdate:modelValue"])]),
                    _: 2
                  }, 1024), _createVNode(_component_el_col, {
                    span: 2
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, {
                      onClick: $event => removeSvgLlist(index)
                    }, {
                      default: _withCtx(() => [_createVNode(_component_Delete)]),
                      _: 2
                    }, 1032, ["onClick"])]),
                    _: 2
                  }, 1024)]),
                  _: 2
                }, 1024);
              }), 128))])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_83]),
              default: _withCtx(() => [_createVNode(_component_el_input_number, {
                size: size.value,
                style: {
                  "width": "45%"
                },
                modelValue: currentSvg.strokeWidth,
                "onUpdate:modelValue": _cache[75] || (_cache[75] = $event => currentSvg.strokeWidth = $event),
                placeholder: "边宽"
              }, null, 8, ["size", "modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_84]),
              default: _withCtx(() => [_createVNode(_component_el_color_picker, {
                modelValue: currentSvg.stroke,
                "onUpdate:modelValue": _cache[76] || (_cache[76] = $event => currentSvg.stroke = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              label: _withCtx(() => [_hoisted_85]),
              default: _withCtx(() => [_createVNode(_component_el_color_picker, {
                modelValue: currentSvg.fill,
                "onUpdate:modelValue": _cache[77] || (_cache[77] = $event => currentSvg.fill = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })])])) : _createCommentVNode("", true)], 4)]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", null, [_createVNode(_component_a_modal, {
        width: "60%",
        style: {
          "top": "20px"
        },
        open: showImg.value,
        "onUpdate:open": _cache[78] || (_cache[78] = $event => showImg.value = $event),
        title: "预览",
        footer: null
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          style: _normalizeStyle([{
            "display": "flex",
            "justify-content": "center"
          }, {
            maxHeight: imageHeight.value,
            overflow: 'hidden'
          }])
        }, [_createElementVNode("div", {
          style: _normalizeStyle({
            border: !myLogo.bg ? '1px solid  var(--primary-color)' : '',
            height: `${myLogo.canvasImgDefaultHeight}px`,
            width: `${myLogo.canvasImgDefaultWidth}px`
          })
        }, [_createElementVNode("div", {
          id: "content",
          ref: "content",
          style: _normalizeStyle({
            transform: myLogo.skew ? `skew(${myLogo.skew}deg, 0)` : '' /* 第一个值是X轴倾斜，第二个值是Y轴倾斜 */,

            borderRadius: myLogo.borderRadius ? `${myLogo.borderRadius}px` : '',
            position: 'relative',
            height: '100%',
            width: '100%',
            background: myLogo.bg,
            overflow: 'hidden' //元素超出隐藏
          })
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myLogo.texts, (text, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "my-huabu",
            key: index,
            style: _normalizeStyle({
              zIndex: 999,
              border: text.borderSize && text.borderColor ? `${text.borderSize}px ${text.borderColor} solid` : 'none',
              position: 'absolute',
              transform: text.transformRotate ? 'rotate(' + `${text.transformRotate}deg` + ')' : '',
              top: `${text.top}px`,
              left: `${text.left}px`,
              borderRadius: text.borderRadius ? `${text.borderRadius}px` : '',
              writingMode: text.isFlex == '竖排' ? 'vertical-rl' : '',
              boxShadow: text.isBoxShadow ? `${text.boxShadowColor}  ${text.boxShadowTop}px ${text.boxShadowLeft}px ${text.boxShadowBottom}px` : ''
            })
          }, [_createElementVNode("span", {
            style: _normalizeStyle({
              fontFamily: text.fontFamily,
              color: text.isXuncai ? 'transparent' : text.color,
              background: text.isXuncai ? text.bg : text.textBg ? text.textBg : 'transparent',
              webkitBackgroundClip: text.bg ? 'text' : '',
              fontSize: `${text.fontSize}px`,
              paddingTop: text.textTopPadding ? `${text.textTopPadding}px` : '',
              paddingRight: text.textRightPadding ? `${text.textRightPadding}px` : '',
              paddingLeft: text.textLeftPadding ? `${text.textLeftPadding}px` : '',
              paddingBottom: text.textBottomPadding ? `${text.textBottomPadding}px` : '',
              fontStyle: text.isItalic == '是' ? 'italic' : '',
              whiteSpace: 'nowrap' /* 防止文本换行 */,
              overflow: 'hidden' /* 隐藏溢出的内容 */,
              fontWeight: text.fontWeight ? text.fontWeight : ''
            })
          }, _toDisplayString(text.inputContent), 5)], 4);
        }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(myLogo.imgs, (i, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(i.isMask ? logoImgs.value : ''),
            style: _normalizeStyle({
              cursor: isFill.value ? 'url(https://itlifetime.com/resources/xiaochengxu/1711466115578.png)' : 'crosshair',
              position: 'absolute',
              top: `${i.top}px`,
              left: `${i.left}px`,
              transform: i.transform3d ? `perspective(${i.perspective3d}px) rotate3d(${i.x3d},${i.y3d},${i.z3d},${i.deg3d}deg)` : i.transformRotate ? 'rotate(' + `${i.transformRotate}deg` + ')' : '',
              width: `${i.width}px`,
              height: `${i.height}px`
            })
          }, [_createElementVNode("img", {
            src: i.src,
            style: _normalizeStyle({
              filter: i.grayscale ? `grayscale(${i.grayscale}%)` : i.filterBlur ? `blur(${i.filterBlur}px)` : i.brightness ? `brightness(${i.brightness})` : i.sepia ? `sepia(${i.sepia}%)` : i.saturate ? `saturate(${i.saturate}%)` : '',
              width: '100%',
              height: '100%',
              opacity: i.opacity ? i.opacity / 10 : ''
            })
          }, null, 12, _hoisted_86)], 6);
        }), 128))], 4)], 4)], 4), _createElementVNode("div", {
          class: "custom-btn",
          onClick: newImage
        }, "下载")]),
        _: 1
      }, 8, ["open"])])]);
    };
  }
};